/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Block} from 'baseui/block'
import {Layer} from 'baseui/layer'
import React, {createRef} from 'react'
import {colors} from '../../utils/config'
import {
  Footer,
  FooterMobileMenu,
  FooterMobileMenuWrapper,
  Header,
  Helmet,
  Sidebar,
  Toaster,
} from '../app'

const layerRef = createRef()

const BaseLayout = ({children}) => {
  return (
    <>
      <Helmet title="Secret of the Source Code" />
      <Block
        overrides={{
          Block: {
            style: {
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            },
          },
        }}
      >
        <Header />
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({
                backgroundColor: $theme.colors.primary50,
                display: 'flex',
                flex: '1 1 auto',
              }),
            },
          }}
        >
          <Block
            overrides={{
              Block: {
                style: ({$theme}) => ({
                  display: 'none',
                  [$theme.media.small]: {
                    display: 'block',
                  },
                  paddingTop: $theme.sizing.scale800,
                  width: 'min-content',
                  [$theme.media.large]: {
                    paddingRight: $theme.sizing.scale800,
                    width: '18rem',
                  },
                }),
              },
            }}
          >
            <Block
              overrides={{
                Block: {
                  style: ({$theme}) => ({
                    display: 'block',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: $theme.sizing.scale0,
                    borderLeftColor: 'transparent',
                    marginBottom: $theme.sizing.scale600,
                    marginLeft: $theme.sizing.scale600,
                    marginRight: $theme.sizing.scale600,
                    marginTop: $theme.sizing.scale600,
                    paddingBottom: $theme.sizing.scale400,
                    paddingLeft: $theme.sizing.scale400,
                    paddingRight: $theme.sizing.scale400,
                    paddingTop: $theme.sizing.scale400,
                    ...$theme.typography.HeadingXSmall,
                    [$theme.media.medium]: {
                      ...$theme.typography.HeadingLarge,
                    },
                    [$theme.media.large]: {display: 'none'},
                  }),
                },
              }}
            >
              <FontAwesomeIcon icon="ellipsis-h" color={colors.mono400} />
            </Block>
            <Sidebar />
          </Block>
          <Block
            overrides={{
              Block: {
                style: ({$theme}) => ({
                  paddingLeft: $theme.sizing.scale800,
                  paddingRight: $theme.sizing.scale800,
                  paddingTop: $theme.sizing.scale800,
                  width: '100%',
                }),
              },
            }}
          >
            {children}
          </Block>
        </Block>
        <div>TESTDIVHEREEEE</div>
        <Footer alignCopyright="right" />
        <Layer>
          <FooterMobileMenuWrapper forwardedRef={layerRef}>
            <FooterMobileMenu />
          </FooterMobileMenuWrapper>
        </Layer>
        <Toaster />
      </Block>
    </>
  )
}

export default BaseLayout
